module.exports = __webpack_public_path__ + "static/img/shl_introduce_tab_member_selected.c09bb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_introduce_tab_member_selected.png
// module id = 6wzI
// module chunks = 5